/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many metrics work best?`)
};

const es_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas métricas funcionan mejor?`)
};

const de_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Kennzahlen funktionieren am besten?`)
};

const nl_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel metrics werken het beste?`)
};

const fr_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de métriques fonctionnent le mieux ?`)
};

const it_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante metriche funzionano meglio?`)
};

const pt_br2_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas métricas funcionam melhor?`)
};

const pt_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas métricas funcionam melhor?`)
};

const ja_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指標はいくつが最適ですか？`)
};

const zh_radar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多少个指标效果最好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_faq_q2", locale)
	if (locale === "en") return en_radar_faq_q2(inputs)
	if (locale === "es") return es_radar_faq_q2(inputs)
	if (locale === "de") return de_radar_faq_q2(inputs)
	if (locale === "nl") return nl_radar_faq_q2(inputs)
	if (locale === "fr") return fr_radar_faq_q2(inputs)
	if (locale === "it") return it_radar_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_radar_faq_q2(inputs)
	if (locale === "pt") return pt_radar_faq_q2(inputs)
	if (locale === "ja") return ja_radar_faq_q2(inputs)
	return zh_radar_faq_q2(inputs)
};